import 'flatpickr';

export default {

  init() {
    // JavaScript to be fired on the my-account page
    // initialization of chart pies
    const items = $.HSCore.components.HSChartPie.init('.js-pie');
  },
  finalize() {
    // JavaScript to be fired on the my-account page
    ($ => {
      function get2DigitFmt(val) {
        return (`0${val}`).slice(-2);
      }


      $(function () {
        const $datepicker = $('#dtaUserEventcalendar');
        const $datepickerMap = $('#dtaMapcalendar');
        const dates = $datepicker.data('rp-event-dates');

        $('.closeEvent').on("click", function () {
          $('#secondContent').hide();
          $( "#firstContent" ).animate({
            width: "toggle"
          }, 500, function() {
            // Animation complete.
          });

        });

        if ($datepicker.length) {
          $datepicker.flatpickr({
            inline: true,
            mode: 'single',
            dateFormat: 'd M Y',
            shorthandCurrentMonth: true,
            onDayCreate(dObj, dStr, fp, dayElem) {
              const date = $(dayElem)[0].dateObj;
              const key = `${date.getFullYear()}-${get2DigitFmt(date.getMonth() + 1)}-${get2DigitFmt(date.getDate())}`;

              if ($.inArray(key, dates) !== -1) {
                $(dayElem).addClass('has-event');
                $(dayElem).addClass('js-animation-link');
                $(dayElem).attr('data-target', '#secondContent');
                $(dayElem).attr('data-link-group', 'groups');
                $(dayElem).attr('data-animation-in', 'slideInUp');
              }
            },
          });
        }

        if ($datepickerMap.length) {
          $datepickerMap.flatpickr({
            inline: true,
            mode: 'single',
            dateFormat: 'd M Y',
            shorthandCurrentMonth: true,
            onDayCreate(dObj, dStr, fp, dayElem) {
              const date = $(dayElem)[0].dateObj;
              const key = `${date.getFullYear()}-${get2DigitFmt(date.getMonth() + 1)}-${get2DigitFmt(date.getDate())}`;

              if ($.inArray(key, dates) !== -1) {
                $(dayElem).addClass('has-event');
                $(dayElem).attr('data-slide-to', key);

              }
            }
          });
        }
      });
    })(jQuery);



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/account.js